const isKeyframesTarget = (v) => {
  return Array.isArray(v);
};
export {
  isKeyframesTarget
};
